
import { Company } from "./company";
import FirestoreModel, { DocRef } from "../FirestoreModel";
import {DateTime} from "luxon";
import { Bay } from "./bay";
import { Customer } from "./customer";

export class Reservation extends FirestoreModel<Reservation>() {

  static collectionPath = (companyId: string) => [...Company.refPath(companyId), "reservations"];
  static refPath = (companyId: string, reservationId: string) => [...this.collectionPath(companyId), reservationId];
  static collection(companyId: string) {
    return this.pathToCollection(this.collectionPath(companyId));
  }
  static ref(companyId: string, reservationId: string) {
    return super.pathToRef(this.refPath(companyId, reservationId));
  }

  duration: number;
  start: DateTime<true>;
  usedMinutes: number;
  appliedCredits: number;
  purchasedMinutes: number;
  purchasedValue: number | undefined;
  createdAt: DateTime;
  cancelledAt: DateTime | null | undefined;
  bay: DocRef<Bay>;
  bayName: string | null | undefined;
  location: DocRef<Location>;
  refunded: boolean;
  customer: DocRef<Customer>;
  invoiceItem: string | null | undefined;

  constructor(snapshot: any) {
    super(snapshot);
    const data = snapshot.data();
    this.duration = data.duration;
    const start = DateTime.fromMillis(data.start.toMillis()).toUTC();
    if(!start.isValid) {
      throw new Error(`invalid start date ${data.start}`);
    }
    this.start = start;
    this.createdAt = DateTime.fromMillis(data.createdAt.toMillis());
    this.usedMinutes = data.usedMinutes;
    this.appliedCredits = data.appliedCredits;
    this.purchasedMinutes = data.purchasedMinutes;
    this.purchasedValue = data.purchasedValue;
    this.cancelledAt = data.cancelledAt ? DateTime.fromMillis(data.cancelledAt.toMillis()) : null;
    this.bay = data.bay
    this.location = data.location
    this.refunded = !!(data.refunded)
    this.customer = data.customer
    this.invoiceItem = data.invoiceItem;
    this.bayName = data.bayName ? data.bayName : null;
  }

  get end() {
    return this.start.plus({minutes: this.duration});
  }
}
